// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Ha8Z","list":"styles_list__1rJys"};